// src/App.jsx
import Onboarding from "./components/Onboarding";

// import { loadStripe } from "@stripe/stripe-js";
// import config from "./config/properties.json";

// const stripePromise = loadStripe(config.stripePublicKey);
// const sessionId = "cs_test_a1jx8x2TT3YoSmi76vzT2KWSqM1YExR0u8CAsvGkzIQopv1ovzqC2IH0Sj"; // Replace with actual session ID
//use the below function to navigate to the stripe chekout page (on button click, say)
//stripe.redirectToCheckout({ sessionId: data.sessionId });
export default function WebShop({
  basketRefId,
  affilliateRef,
  promoCode,
  planSelected,
  prev,
}) {

  return (
    <>

      {/* Onboarding Flow Container, wrap in a Stripe checkout provider so that we can render stripe
      whenever we want */
      /* If you want to use the session ID instead of client secret, you can pass it directly */
      /* <Onboarding sessionId={sessionId} /> */}
      <div className="container">
        <Onboarding basketRefId={basketRefId} affilliateRef={affilliateRef} promoCode={promoCode} planSelected={planSelected} />
      </div>
    </>
  );
}
